module.exports = __webpack_public_path__ + "img/title1.b4828791.png";